import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DAO } from './modal/DAO';
import { Router, NavigationEnd } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ServiceLayer } from './services/serviceLayer';
import { environment } from '../environments/environment';
import { AuthService } from '@auth0/auth0-angular';
declare function callScript():any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'servicecenter';
  userName: string;
  public currentPath: string = '';
  public notification:any;
  public isBFMInternal:boolean = false;
  public IsNotificationExist:Boolean = false;
  public IsMaintenanceAlertExist:Boolean = false;

  constructor(public dao:DAO,public serviceLayer:ServiceLayer,public router:Router, public auth: AuthService) {
  }

  async ngOnInit() {
    this.dao.loginUserDetail = JSON.parse(window.localStorage.getItem("loginUserDetails"));
	// Google analytics
	sessionStorage.setItem('IsProdEnvironment',JSON.stringify(environment.production));
    callScript();
    if(this.dao.loginUserDetail?.isinternal && (this.dao.loginUserDetail?.email).includes("@berkleymarine.com")){
      this.isBFMInternal = this.dao.loginUserDetail?.isinternal;
    }
    else {
      this.isBFMInternal = false;
    }
      // this.notification = await this.serviceLayer.getNotifications('BFM','BR');
      // if(this.notification != undefined && this.notification != null && this.notification.type == "SITEDOWN"){
      //   this.router.navigate(['/xps/maintenance']);
      // }
    this.currentPath = window.location.pathname;
  }
  
  public routeChange(){
    let userData:any={};
    userData.Email = this.dao?.loginUserDetail?.email;
    userData.ProgressToPage = this.currentPath == '/xps/landing' ? 'Home' : 
                              this.currentPath == '/xps/search' ? 'View all Policies and Quotes' : 
                              this.currentPath == '/xps/reportclaim' ? 'Report a Claim' : 'Request Evidence of Insurance';
    if(this.currentPath == '/xps/policyQuotes'){
      userData.ProgressToPage = window.localStorage.getItem("policyType");
    }
    if(this.currentPath == '/xps/search' && this.isBFMInternal){
      this.currentPath = '/xps/unauthenticated';
      this.router.navigate(['/xps/unauthenticated']);
    }
    userData.ActionType = "Menu Change";
    this.serviceLayer.postUserActivity(userData);
  }
  GetNotificationMessage(IspageDisable: Boolean) {
    this.IsNotificationExist= IspageDisable;
   }
  GetMaintenanceAlertNotificationMessage(IsAlertExist: Boolean) {
    this.IsMaintenanceAlertExist= IsAlertExist;
   }
}